import { filterConfiguration } from 'app/components/filters/filters-panel/filter-configuration';
import { Filter, FilterTypes } from 'app/components/filters/types';
import { endpoint } from 'app/area/filters/constants';
import { FilterCode } from './filter-code';
import { createConditionValue } from './create-condition-value';
import { createFavouriteCondition } from 'app/components/filters/filters-panel/conditions/create-conditions';
import { getConditionForOperator } from '../get-condition';

export const selectMultipleConfiguration = {
  [FilterTypes.SelectMultiple]: filterConfiguration(
    FilterCode,
    endpoint.filterOptionsFor
  )
};

export const selectMultipleConditionMapper = (editingValues: any) => {
  const mapper = (filter: Filter) => {
    let condValIndex = 1;

    const editingValue = editingValues?.[filter.id];
    const value = editingValue?.value;
    const conditionValue = createConditionValue(condValIndex++, filter, value);
    const originalCondition = getConditionForOperator(filter.conditions, filter.advancedField.valueOperator);

    return conditionValue ? [createFavouriteCondition(filter, conditionValue, originalCondition)] : [];
  };

  return {
    [FilterTypes.SelectMultiple]: mapper,
    [FilterTypes.SelectMultipleFlatSequentialWithCategories]: mapper
  };
};
